/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter/types';
import { BaseFeatureMock } from '../mockServer/featureMock';
import { cashBoxesStatisticsFactory } from './statisticsFactories';
import { CashBoxesStatisticsDto } from './statisticsClient.typings';

const CASH_BOXES_STATISTICS_URL_RE = /1\.0\.0\/statistics\/cashBoxes$/;

class StatisticsFeatureMock extends BaseFeatureMock {
    public readonly cashBoxes = this.route<CashBoxesStatisticsDto>({
        method: 'get',
        url: CASH_BOXES_STATISTICS_URL_RE,
        defaultResponse: () => [200, cashBoxesStatisticsFactory.item()],
        delayMs: 2000,
    });

    protected onReset(): void {
        cashBoxesStatisticsFactory.resetCount();
    }
}

export const statisticsMock = new StatisticsFeatureMock();

export function addStatisticsMockApi(mockAdapter: MockAdapter): void {
    statisticsMock.register(mockAdapter, { delay: true });
}
